import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";

import Utils from "../../../Utils";
import ContextComponent from "../../../AppContext";

const EditBrandPage = ({ props }) => {
  let { setAlert } = useContext(ContextComponent);
  let tableData = props?.tableData || [];
  let editableBrand = { ...(props?.editableBrand || {}) };
  let editableBrandIndex = props?.editableBrandIndex || {};
  let setTableData = props?.setTableData || (() => {});
  let [brand, setBrand] = useState(editableBrand);
  let [brandFile, setBrandFile] = useState(editableBrand.qrlogoLocation);
  let [domains, setDomains] = useState(editableBrand.domains);
  let [blobFileContent, setBlobFileContent] = useState("");
  let [brandLogoPreview, setBrandLogoPreview] = useState(editableBrand.logo);

  const hideModal = (e) => {
    props.setEditModalCanOpen(false);
  };

  const updateBrand = (e) => {
    const success = (res) => {
      hideModal();
      setAlert({
        show: true,
        message: "Successfully updated brand!",
      });
      let updatedRecord = [
        res.data.id,
        false,
        res.data.name,
        res.data.domains,
        res.data.logo,
      ];
      let tempTableData = [...tableData];
      tempTableData[editableBrandIndex] = updatedRecord;
      // tempTableData.push(updatedRecord);

      // let tempAllBrands = [...props?.allBrands];
      // let currentBrand = tempAllBrands[editableBrandIndex];

      // currentBrand.name = updatedRecord[2];
      // currentBrand.domains = updatedRecord[3];
      // currentBrand.logo = updatedRecord[4];

      props?.setTableData(tempTableData);
    };

    const fail = (err) => {
      console.log(err);
    };

    // let formData = brand;
    let formData = {
      name: brand.name,
      domains: brand.domains,
      logo: blobFileContent,
    };

    // formData.brandUID = editableBrand.brandUID;
    // console.log(formData);

    try {
      Utils.editBrand(formData, editableBrand.id).then(success, fail);
    } catch (e) {
      console.log(e);
    }
  };

  const inputHandler = (e) => {
    let value = e.currentTarget.value;
    let key = e.currentTarget.id;
    setBrand({ ...brand, [key]: value });
  };

  const inputDomainsHandler = (e) => {
    let value = e.currentTarget.value;
    let key = e.currentTarget.id;
    setBrand({ ...brand, [key]: value });
  };

  const inputFileHandler1 = (e) => {
    let file1 = e.currentTarget.files[0];
    // debugger;
    let key = e.currentTarget.id;
    setBrand({ ...brand, [key]: file1 });
  };

  const inputFileHandler = async (e) => {
    let file = e.currentTarget.files[0];

    await Utils.fileToDataUri(file).then((dataUri) => {
      // console.log(dataUri);
      setBlobFileContent(dataUri);
      setBrandLogoPreview(dataUri);
    });
  };

  useEffect(() => {}, [props.editModalCanOpen]);

  const handleClose = (e) => {
    props.setEditModalCanOpen(false);
  };

  return (
    <>
      {
        <Modal centered show={props.editModalCanOpen} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Update brand</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="indi-add-form-wrapper d-flex flex-column">
                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="Brand name">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="name"
                        placeholder="Enter brand name"
                        defaultValue={brand.name}
                        autoComplete="off"
                        onChange={inputHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>
                <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="Domains">
                      <Form.Control
                        type="text"
                        className="indi-input-field"
                        id="domains"
                        placeholder="Enter domains"
                        defaultValue={brand.domains}
                        autoComplete="off"
                        onChange={inputDomainsHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div>

                {/* <div className="indi-add-form-item d-flex flex-column">
                  <div className="indi-add-form-item-input row">
                    <FloatingLabel label="Brand file">
                      <Form.Control
                        type="file"
                        className="indi-input-field"
                        id="file"
                        placeholder="Upload file"
                        // defaultValue={brand.qrlogoLocation}
                        onChange={inputFileHandler}
                      />
                    </FloatingLabel>
                  </div>
                </div> */}

                <div className="indi-add-form-item d-flex flex-row align-items-center">
                  <div className="indi-add-form-item-label">
                    Upload brand logo
                  </div>
                  <div className="indi-add-form-item-input">
                    <input
                      type="file"
                      id="file"
                      className="indi-upload-picture-file-input"
                      onChange={inputFileHandler}
                    />
                    <div className="indi-add-img-wrapper"></div>
                  </div>
                  <div
                    className="indi-img-preview indi-img-preview"
                    style={{
                      backgroundImage: `url("${brandLogoPreview}")`,
                    }}
                  ></div>
                </div>
              </div>

              <div className="indi-add-footer">
                <div className="indi-add-page-footer-btn-wrapper float-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={hideModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={updateBrand}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      }
    </>
  );
};

export default EditBrandPage;
